type Options = Partial<ToggleOptions>;

export interface ToggleElement extends HTMLElement {
  toggle?: Toggle;
}

interface ToggleOptions {
  activeClass: string;
  trigger: string;
  target: string;
}

export class Toggle {
  static defaults: ToggleOptions = {
    activeClass: 'is-active',
    target: '[data-toggle-target]',
    trigger: '[data-toggle-trigger]',
  };
  element: ToggleElement;
  clickHandler: EventListener;
  keyDownHandler: EventListener;
  options: ToggleOptions;
  trigger: HTMLElement;

  constructor(element: ToggleElement, options: Options) {
    if (!element || element.toggle) {
      return;
    }

    this.element = element;
    this.options = {
      ...Toggle.defaults,
      ...this.element.dataset,
      ...options,
    };

    const trigger = this.element.querySelector(
      this.options.trigger,
    ) as HTMLElement;

    if (!trigger) {
      return;
    }

    this.trigger = trigger;
    this.bind();
  }

  bind() {
    this.clickHandler = this.handleClick.bind(this);
    this.trigger.addEventListener('click', this.clickHandler);

    this.keyDownHandler = this.handleKeyDown.bind(this) as EventListener;
    this.trigger.addEventListener('keydown', this.keyDownHandler);
  }

  handleClick() {
    this.toggle();
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault();
      this.toggle();
    }
  }

  isActive(): boolean {
    return this.element.classList.contains(this.options.activeClass);
  }

  toggle() {
    const active = this.isActive();

    this.element.classList.toggle(this.options.activeClass, !active);
    this.element.setAttribute('aria-hidden', String(!active));
  }

  unbind() {
    this.trigger.removeEventListener('click', this.clickHandler);
  }

  destroy() {
    this.unbind();
    this.element.toggle = undefined;
  }
}
